// 3rd
import { Model } from '@vuex-orm/core';
import moment from 'moment';

export default class CompletedOrder extends Model {
    static entity = 'completed-orders';

    static fields() {
        return {
            id: this.attr(null),
            created_at: this.attr(null),
            delivery_service: this.attr(null),
            description: this.attr(null),
            order: this.attr(null),
            order_number: this.attr(null),
            price: this.attr(null),
            product: this.attr(null),
            quantity: this.attr(null),
            status: this.attr(null),
            tracking_id: this.attr(null),
        }
    }

    static getByYear(year) {
        if (!year) return CompletedOrder.all();
        return CompletedOrder.query().where('created_at', (ca) => Number(moment.unix(ca).format("YYYY")) === year).get();
    }

    static getDetails(id) {
        return CompletedOrder.query().withAll().find(id);
    }

    static getShippingInfo(id) {
        let itemToReturn = null;
        const order = CompletedOrder.all();
        order.forEach((o) => {
            o.order.order_items.forEach((orderItem) => {
                if (orderItem.id === Number(id)) {
                    itemToReturn = o;
                }
            });
        });
        return itemToReturn.order;
    }

    static getAvailableYearsForFilter() {
        const orders = CompletedOrder.all();
        const years = orders.map((order) => {
            return Number(moment.unix(order.created_at).format("YYYY"));
        });
        return Array.from(new Set(years));
    }
}
